export default {
 
  zh: {
    rule: 'Rules',
    register:`1. Monthly rewards: When participant‘s recharge reaches that specific amount, participant must manually click the "receive" button to receive the entire package gift<br/>
    2. Rewards reset on the 1st of every month.Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    3. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    4. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    5. After obtaining the Recharge Stars for 3 consecutive time. you will have it permanently<br/>
    6. App has the final right of this activity Monthly recharge ID upgrade rules<br/>
    7. The monthly time is Saudi time from the 1st of each month to the 1st of next month.<br/>
    8. For more details contact ID 1.`,
    successful:"The operation was successful",
    monthlyBenefits:"Monthly Benefits",
    receive:"Receive",
  },
  en: {
    rule: 'Rules',
    register:`1. Monthly rewards: When participant‘s recharge reaches that specific amount, participant must manually click the "receive" button to receive the entire package gift<br/>
    2. Rewards reset on the 1st of every month.Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    3. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    4. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    5. After obtaining the Recharge Stars for 3 consecutive time. you will have it permanently<br/>
    6. App has the final right of this activity Monthly recharge ID upgrade rules<br/>
    7. The monthly time is Saudi time from the 1st of each month to the 1st of next month.<br/>
    8. For more details contact ID 1.`,
    successful:"The operation was successful",
    monthlyBenefits:"Monthly Benefits",
    received:"Received",
    receive:"Receive",
    timeR: 'Count down: ',
    days: 'days',
  },
  tr: {
    rule: 'Kural',
    register:`1. Aylık Ödüller: Katılımcının çekimi belirli bir miktara ulaştığında, paket hediyesinin tamamını almak için katılımcının manuel olarak "Al" düğmesine tıklaması gerekir.<br/>
    2. Ödüller her ayın 1'inde sıfırlanır. Talep edilmeyen işlemlerde, katılımcılar ödüllerini kullanamazlarsa ödüllerini kaybedeceklerdir. App eksik veya alınmamış hediyelerden sorumlu olmayacaktır<br/>
    3. Özel ID alan kullanıcılar için. Lütfen App ekibiyle iletişime geçin. Özel Hediye yapımların üretimi 7 güne ihtiyaç duyacaktır.<br/>
    4. Yeniden yükleme etkinliği her ayın 1'inden bir sonraki ayın 1'ine kadar TR zamanına göre yapılacaktır.<br/>
    5. Art arda 3 kez Şarj Yıldızını aldıktan sonra ona kalıcı olarak sahip olacaksın<br/>
    6.Bu aktivitenin son hakkı App'ye aittir. <br/>
    Aylık yeniden yükleme kimliği yükseltme kuralları<br/>
    7. Aylık zaman, her ayın 1'inden sonraki ayın 1'ine kadar TR zamanıdır.<br/>
    8. Daha fazla ayrıntı için ID: SELMAN ile iletişime geçin.`,
    successful:"İşlem Başarılı Oldu",
    monthlyBenefits:"Aylık Avantajlar",
    received:"Alındı",
    receive:"Al",
    timeR: 'Kalan süre: ',
    days: 'gün'
  },
  ar: {
    rule: 'القواعد',
    register:`١. المكافآت الشهرية: عندما يصل شحن المشترك إلى المبلغ المحدد، يجب على المشترك النقر يدويًا على زر "استلام" لتلقي هدية الحزمة بأكملها
    <br/>٢. يتم إعادة تعيين المكافآت في اليوم الأول من كل شهر. ستفقد المكافآت اذا لم يتم استلامها قبل نهاية الموعد المحدد.ولن تكون الادارة مسؤوله عن الهدايا المفقودة
    <br/> ٣. للمستخدمين الذين حصلوا على معرف خاص بهم. يرجى الاتصال بفريق الادارة. سوف تحتاج  الهدايا الخاصة إلى 7 أيام لإنتاجها
    <br/> ٤. سيتم احتساب نشاط إعادة الشحن حسب توقيت المملكة العربية السعودية اعتباراً من اليوم الأول من كل شهر وحتى اليوم الأول من الشهر التالي
    <br/> ٥. اذا حصلت على نجم الشحن لثلاث مرات متتالية، سوف تحصل عليه بشكل دائم
    <br/> ٦. للإدارة كامل الصلاحيات لتعديل او ترقية هذا النشاط وقواعده
    <br/> ٧. التوقيت الشهري هو توقيت السعودية من الأول من كل شهر إلى الأول من الشهر التالي
    <br/> ٨.  لمزيد من التفاصيل تواصل ب آيدي رقم 1`,
    successful:"العملية كانت ناجحه",
    monthlyBenefits:"المكافأت الشهرية",
    received:"تم الإستلام",
    receive:"إستلام",
    timeR: 'العد التنازلي',
    days: 'أيام',
  },
  pt:{
    "rule": "Regras",
    "register": `1. Recompensas mensais: Quando o recarregamento do participante atingir o valor específico, o participante deve clicar manualmente no botão "receber" para receber o pacote completo de presentes.<br/>
    2. As recompensas são redefinidas no primeiro dia de cada mês. Ações não reclamadas, os participantes perderão seus prêmios se não resgatarem seus prêmios. O aplicativo não será responsável por presentes ausentes.<br/>
    3. Para usuários que receberam seu ID especial. Entre em contato com a equipe do aplicativo. A produção de presentes especiais levará 7 dias para ser produzida.<br/>
    4. A atividade de recarga será com base no horário da Arábia Saudita, do 1º dia de cada mês até o 1º do próximo mês.<br/>
    5. Após obter as Estrelas de Recarga por 3 vezes consecutivas, você as terá permanentemente.<br/>
    6. O aplicativo tem o direito final sobre as regras de atualização do ID de recarga mensal.<br/>
    7. O período mensal é o horário da Arábia Saudita, do 1º dia de cada mês até o 1º do próximo mês.<br/>
    8. Para mais detalhes, entre em contato com o ID 1.`,
    "successful": "A operação foi bem-sucedida",
    "monthlyBenefits": "Benefícios Mensais",
    "received": "Recebido",
    "receive": "Receber",
    "timeR": "Contagem regressiva: ",
    "days": "dias"
},
    id:{
    "rule": "Aturan",
    "register": `1. Hadiah bulanan: Ketika pengisian ulang peserta mencapai jumlah tertentu, peserta harus mengklik tombol "terima" secara manual untuk menerima hadiah paket lengkap.<br/>
    2. Hadiah direset pada tanggal 1 setiap bulan. Aksi yang tidak diklaim, peserta akan kehilangan hadiahnya jika gagal menebus hadiah. Aplikasi tidak akan bertanggung jawab atas hadiah yang hilang.<br/>
    3. Untuk pengguna yang menerima ID Khusus mereka. Silakan hubungi tim aplikasi. Produksi hadiah khusus membutuhkan waktu 7 hari untuk diproduksi.<br/>
    4. Aktivitas pengisian ulang akan berdasarkan waktu KSA dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>
    5. Setelah mendapatkan Bintang Pengisian Ulang selama 3 kali berturut-turut, Anda akan memilikinya secara permanen.<br/>
    6. Aplikasi memiliki hak akhir atas aturan peningkatan ID pengisian ulang bulanan.<br/>
    7. Waktu bulanan adalah waktu Saudi dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>
    8. Untuk detail lebih lanjut hubungi ID 1.`,
    "successful": "Operasi berhasil",
    "monthlyBenefits": "Manfaat Bulanan",
    "received": "Diterima",
    "receive": "Terima",
    "timeR": "Hitung mundur: ",
    "days": "hari"
},
    uz:{
    "rule": "Qoidalar",
    "register": `1. Oylik mukofotlar: Ishtirokchi to'lov miqdori ma'lum bir summaga yetganida, ishtirokchi to'liq sovg'a paketini olish uchun "qabul qilish" tugmasini qo'lda bosishi kerak.<br/>
    2. Mukofotlar har oyning 1-kunida yangilanadi. Qabul qilinmagan harakatlar, ishtirokchilar o'z mukofotlarini olishmasa, mukofotlarini yo'qotadilar. Ilova yo'qolgan sovg'alar uchun javobgar emas.<br/>
    3. Maxsus ID olgan foydalanuvchilar. Iltimos, ilova jamoasi bilan bog'laning. Maxsus sovg'alar ishlab chiqarish 7 kun davom etadi.<br/>
    4. To'lov faoliyati har oyning 1-kunidan keyingi oyning 1-kunigacha, KSA vaqti bo'yicha amalga oshiriladi.<br/>
    5. To'lov yulduzlarini 3 marta ketma-ket olishdan so'ng, ularni doimiy saqlaysiz.<br/>
    6. Ilovada ushbu faoliyat uchun yakuniy huquq bor, oylik to'lov ID yangilanish qoidalari.<br/>
    7. Oylik vaqt har oyning 1-kunidan keyingi oyga qadar, Saudiya vaqti bilan.<br/>
    8. Batafsil ma'lumot uchun ID 1 bilan bog'laning.`,
    "successful": "Amaliyot muvaffaqiyatli yakunlandi",
    "monthlyBenefits": "Oylik Foyda",
    "received": "Olingan",
    "receive": "Qabul qilish",
    "timeR": "Qoldiq vaqti: ",
    "days": "kun"
},
    ru:{
    "rule": "Правила",
    "register": `1. Ежемесячные награды: Когда сумма пополнения участника достигает определенной суммы, участник должен вручную нажать кнопку "получить", чтобы получить весь пакет подарков.<br/>
    2. Награды сбрасываются 1-го числа каждого месяца. Неизвещенные действия, участники потеряют свои призы, если не заберут их. Приложение не несет ответственности за утерянные подарки.<br/>
    3. Для пользователей, получивших свой специальный ID. Пожалуйста, свяжитесь с командой приложения. Производство специальных подарков займет 7 дней.<br/>
    4. Активность пополнения будет производиться по времени KSA с 1-го числа каждого месяца до 1-го числа следующего месяца.<br/>
    5. После получения звезд пополнения 3 раза подряд вы будете иметь их навсегда.<br/>
    6. Приложение имеет окончательное право на эти правила обновления ID пополнения ежемесячно.<br/>
    7. Ежемесячное время - по времени Саудовской Аравии с 1-го числа каждого месяца до 1-го числа следующего месяца.<br/>
    8. Для получения дополнительной информации свяжитесь с ID 1.`,
    "successful": "Операция прошла успешно",
    "monthlyBenefits": "Ежемесячные льготы",
    "received": "Получено",
    "receive": "Получить",
    "timeR": "Обратный отсчет: ",
    "days": "дней"
},
    fa:{
    "rule": "قوانین",
    "register": `1. جوایز ماهانه: زمانی که شارژ شرکت کننده به مقدار مشخصی برسد، شرکت کننده باید به صورت دستی روی دکمه "دریافت" کلیک کند تا بسته کامل هدیه را دریافت کند.<br/>
    2. جوایز در اول هر ماه تنظیم می‌شوند. اقداماتی که دریافت نشده‌اند، شرکت کنندگان جوایز خود را از دست می‌دهند اگر نتوانند جوایز خود را پس بگیرند. اپلیکیشن مسئول هیچ هدیه‌ای که گم شود نیست.<br/>
    3. برای کاربرانی که شناسه ویژه خود را دریافت کرده‌اند. لطفاً با تیم اپلیکیشن تماس بگیرید. تولید هدیه‌های ویژه 7 روز طول می‌کشد.<br/>
    4. فعالیت شارژ براساس زمان KSA از اول هر ماه تا اول ماه بعد خواهد بود.<br/>
    5. پس از دریافت ستارگان شارژ برای 3 بار متوالی، شما آنها را به صورت دائمی خواهید داشت.<br/>
    6. اپلیکیشن حق نهایی این فعالیت را دارد، قوانین ارتقای ID شارژ ماهانه.<br/>
    7. زمان ماهانه، زمان عربستان سعودی از اول هر ماه تا اول ماه بعد است.<br/>
    8. برای جزئیات بیشتر با ID 1 تماس بگیرید.`,
    "successful": "عملیات موفقیت‌آمیز بود",
    "monthlyBenefits": "مزایای ماهانه",
    "received": "دریافت شده",
    "receive": "دریافت کردن",
    "timeR": "شمارش معکوس: ",
    "days": "روز"
}





}



// WEBPACK FOOTER //
// src/pages/activity/ruby-activity/lang.js